import { required } from '@vuelidate/validators';

export const rules = {
  measureValue: { required },
  positionFromHub: { required },
  severity: { required },
};
